import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Button } from '@chapche/ui';
import { ConeIcon } from '../appearence/icons/cone_icon';
import { useTranslation } from 'react-i18next';
import FiltersListItem from './FiltersListItem';
import FiltersListStatus from './FiltersListStatus';
import { 
    FILTER_GROUP_NAME_STATUS, 
    FILTER_TYPE_CHECKBOX, 
    FILTER_TYPE_MAX_AND_MIN, 
    FILTER_TYPE_SELECT, 
    FILTER_NAME_IS_DELETED, 
    FILTER_NAME_IS_NOT_VALID,
} from '../constant';
import {Filter, FilterGroup, ItemsStorageService} from "./filtering/itemsStorageService";
import { filtersManager } from './filtering/filtersManager';

const createFiltersGroupList = (itemsStorageService: ItemsStorageService,  listOfFilters: Filter[]): FilterGroup[] => {
    return [...new Set(listOfFilters.map(it => it.filterGroupName))].map(it => {
        const result = itemsStorageService.getAnyFiltersByGroup(it);
        return {
            filterGroupName: result.filterGroupName,
            filterType: result.filterType,
        };
    });
};

const findDropdownClass = (listLength) => {
    return Math.ceil(listLength / 3) === 1 ? 
        'product__dropdown-list_small' 
        : 
        Math.ceil(listLength / 3) === 2 ? 
            'product__dropdown-list_full-list' 
            : 
            '';
};

interface FiltersListDropdownProps {
    itemsStorageService: ItemsStorageService,
}

function FiltersListDropdown({ itemsStorageService }: FiltersListDropdownProps) {
    const { i18n } = useTranslation();
    const [filtersListIsOpen, setFiltersListIsOpen] = useState(false);
    const [filterGroups, setFilterGroups] = useState <FilterGroup[]> ([]);
    const [searchParams, setSearchParams] = useSearchParams();

    const changeFiltersListState = (value) => {
        setFiltersListIsOpen(value);
    };

    const reloadPossibleFilters = () => {
        setFilterGroups(createFiltersGroupList(itemsStorageService, itemsStorageService.getPossibleFilters()));
    };

    const cleanFiltersList = () => {
        setSearchParams({});
        setFilterGroups([]);
        itemsStorageService.cleanFilterValues();
        filtersManager.notifyFiltersChanged();
    };

    useEffect(() => {
        filtersManager.registerOpenStateObserver(changeFiltersListState);
        itemsStorageService.registerFiltersChangingObserver(reloadPossibleFilters);
        setFilterGroups(createFiltersGroupList(itemsStorageService, itemsStorageService.getPossibleFilters()));
        return () => {
            itemsStorageService.unRegisterFiltersChangingObserver(reloadPossibleFilters);
            filtersManager.unRegisterOpenStateObserver(changeFiltersListState);
        };
    }, []);

    const applyFiltersList = () => {
        const newSearchParams = {};
        itemsStorageService.getCurrentFilters().forEach(filter => {
            if(filter.filterType === FILTER_TYPE_CHECKBOX && filter.value === true) {
                newSearchParams[filter.filterName] = filter.value;
            }
            if(filter.filterType === FILTER_TYPE_MAX_AND_MIN && (filter.max || filter.min)) {
                if(filter.min !== undefined) newSearchParams[`${filter.filterName}.min`] = filter.min;
                if(filter.max !== undefined) newSearchParams[`${filter.filterName}.max`] = filter.max;
            }
            if(filter.filterType === FILTER_TYPE_SELECT && filter.value) {
                newSearchParams[filter.filterName] = filter.value;
            }
        });
        itemsStorageService.changeDeletedItemsView(
            itemsStorageService.getCurrentFilters().findIndex(it => it.filterName === FILTER_NAME_IS_DELETED) >= 0,
        );
        itemsStorageService.changeValidItemsView(
            itemsStorageService.getCurrentFilters().findIndex(it => it.filterName === FILTER_NAME_IS_NOT_VALID) >= 0,
        );
        setSearchParams(newSearchParams);
        setFiltersListIsOpen(false);
        filtersManager.notifyFiltersChanged();
        itemsStorageService.reloadPagesNumber();
        itemsStorageService.notifyFiltersChangingObservers();
    };

    return (
        filtersListIsOpen ? 
            <>
                <div className="modal__wrapper" onClick={() => filtersManager.callToOpen(false)}></div>
                <article className="product__article-list product__dropdown">
                    <ConeIcon nameOfClass="product__dropdown-cone" />
                    <div className="product__dropdown-wrapper">
                        <ul className={`product__dropdown-list ${findDropdownClass(filterGroups.length)}`}>
                            {filterGroups.map(it =>
                                <React.Fragment key={it.filterGroupName}>
                                    {it.filterGroupName === FILTER_GROUP_NAME_STATUS ?
                                        <FiltersListStatus itemsStorageService={itemsStorageService} /> :
                                        <FiltersListItem filterData={it} itemsStorageService={itemsStorageService}/>}
                                </React.Fragment>,
                            )}
                        </ul>
                    </div>
                    <div className="product__dropdown-buttons">
                        <Button
                            variant="outline"
                            className="product__dropdown-button"
                            onClick={() => filtersManager.callToOpen(false)}
                        >
                            {i18n.t(`app.page.product.filters.cancel`)}
                        </Button>
                        <div className="product__dropdown-block">
                            <Button
                                variant="ghost"
                                className="product__dropdown-clean"
                                onClick={cleanFiltersList}
                            >
                                {i18n.t(`app.page.product.filters.clean`)}
                            </Button>
                            <Button className="product__dropdown-button" onClick={applyFiltersList}>
                                {i18n.t(`app.page.product.filters.applyFilter`)}
                            </Button>
                        </div>
                    </div>
                </article>
                
            </>
            :
            null
    );
};

export default FiltersListDropdown;
